module.exports = __webpack_public_path__ + "static/media/image3.da9b5303.png";